import React from "react";
import { GlobalConfigType } from "types/configs";

export const Context = React.createContext<GlobalConfigType | null>(null);

export default Context;
